import { IconWrapper } from '../runtime';
export default IconWrapper('tilting-bar', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.3829 13.7997H13.4004C14.0631 13.7997 14.6004 13.2624 14.6004 12.5997V3.39971C14.6004 2.73697 14.0631 2.19971 13.4004 2.19971H7.3829M7.3829 13.7997H2.60039C1.93765 13.7997 1.40039 13.2624 1.40039 12.5997V3.39971C1.40039 2.73697 1.93765 2.19971 2.60039 2.19971H7.3829M7.3829 13.7997V2.19971M3.40039 5.39971H5.40039M3.40039 7.99971H5.40039M3.40039 10.5997H5.40039",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});